import {Box, Grid, Radio, Typography} from '@yandex-delivery/blocks'
import type {Image, TextWidgetConfig} from '@yandex-delivery/form'
import type {ReactElement} from 'react'

import {tagToUrl} from '../../../lib/createTagToUrl'
import {renderWidget} from '../../../widgets'
import * as classes from './VerticalItem.classes'

export type VerticalItemProps = {
  value: string
  title?: {items: TextWidgetConfig[]} | undefined
  subtitle?: {items: TextWidgetConfig[]} | undefined
  icon: Image
  active?: boolean
  tag?: 'New!'
  onClick: (id: string) => void
}

export function VerticalItem({value, title, subtitle, icon, active, tag, onClick}: VerticalItemProps): ReactElement {
  return (
    <Grid
      className={classes.verticalItem}
      onClick={() => {
        onClick(value)
      }}
      container
    >
      <Box alignItems="flex-start" className={classes.wrapper.top} justifyContent="space-between">
        <img alt="" className={classes.image} src={tagToUrl(icon.image_tag)} />
        <Radio checked={active} className={classes.radio} />
      </Box>
      <Box className={classes.wrapper.content} flexDirection="column">
        <Box my="xs">
          {title && title.items.map(renderWidget)}
          {tag && tag === 'New!' ? (
            <div className={classes.badgeNew}>
              <Typography color="invert" thickness="medium" variant="caption2">
                {tag}
              </Typography>
            </div>
          ) : null}
        </Box>

        {subtitle &&
          subtitle.items.map((item, index) => (
            <Typography key={index} color="minor" variant="caption2">
              {item.text}
            </Typography>
          ))}
      </Box>
    </Grid>
  )
}
